export default __webpack_public_path__ + "static/media/radiobutton_active.316dd39a.svg";